// Hook : son de validation "pluie d'or" — joué aux moments cruciaux
// Activable / désactivable via localStorage. Préchargé en mémoire.
import { useCallback, useRef, useEffect } from 'react';

const STORAGE_KEY = 'bobine_sound_enabled';
const SOUND_URL = '/sounds/pluie-or.mp3';

let cachedAudio = null;
let cachedAudioFailed = false;

const getAudio = () => {
  if (cachedAudioFailed) return null;
  if (!cachedAudio) {
    try {
      cachedAudio = new Audio(SOUND_URL);
      cachedAudio.preload = 'auto';
      cachedAudio.volume = 0.45;
    } catch {
      cachedAudioFailed = true;
      return null;
    }
  }
  return cachedAudio;
};

export const isSoundEnabled = () => {
  if (typeof window === 'undefined') return false;
  const v = window.localStorage.getItem(STORAGE_KEY);
  return v === null ? true : v === '1'; // default ON
};

export const setSoundEnabled = (enabled) => {
  try { window.localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0'); } catch {}
};

export const playGoldSound = () => {
  if (!isSoundEnabled()) return;
  const a = getAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    a.play().catch(() => {});
  } catch {}
};

export default function useGoldSound() {
  const enabledRef = useRef(isSoundEnabled());

  useEffect(() => {
    // Preload on mount
    getAudio();
  }, []);

  const play = useCallback(() => {
    if (!enabledRef.current) return;
    playGoldSound();
  }, []);

  const toggle = useCallback(() => {
    const newVal = !enabledRef.current;
    enabledRef.current = newVal;
    setSoundEnabled(newVal);
    return newVal;
  }, []);

  return { play, toggle, enabled: enabledRef.current };
}
